import _ from "underscore";

import { convertObject } from "../../../lib/utils";
import { MentionSearchLinkInfo } from "../../../types";

import { runQuery } from "../../http";

export const searchEvent = async (
  text: RegExp
): Promise<MentionSearchLinkInfo[] | undefined> => {
  const parseResponse = await runQuery("Event", (query: Parse.Query) => {
    query.matches("title", text, "i");
    //@FIXME this is weird: ts says that keys must be string type here when in parse index.d.ts keys has a K[] type
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    query.select<string>([
      "objectId",
      "title",
      "thumbUrl",
      "thumbImage",
      "imageUrl",
      "image",
    ]);
    query.limit(10);
    return query.find();
  });

  if (!_.isEmpty(parseResponse)) {
    return convertObject(parseResponse).map(
      (item: { id: string; title: string; thumbUrl: string }) => {
        return {
          id: item.id,
          name: item.title,
          imageUrl: item.thumbUrl,
          url: "/event-detail/" + item.id,
        };
      }
    );
  } else return undefined;
};
